import { render, staticRenderFns } from "./HandlerCaseDialog.vue?vue&type=template&id=551ac93c&scoped=true"
import script from "./HandlerCaseDialog.vue?vue&type=script&lang=js"
export * from "./HandlerCaseDialog.vue?vue&type=script&lang=js"
import style0 from "./HandlerCaseDialog.vue?vue&type=style&index=0&id=551ac93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ac93c",
  null
  
)

export default component.exports